import { render, staticRenderFns } from "./VideoWatch.vue?vue&type=template&id=749a0d64&"
import script from "./VideoWatch.vue?vue&type=script&lang=js&"
export * from "./VideoWatch.vue?vue&type=script&lang=js&"
import style0 from "./VideoWatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports